import {
  AthenaEvent,
  HTTPValidationError,
  ValidationError,
} from "@evidenceb/athena-event-storage-schemas";

export type GetEvents200ResponseBody = AthenaEvent<any, any>[];

export interface GetEvents422ResponseBody extends HTTPValidationError {
  detail: ValidationError[];
}

export function toDateQueryParam(date?: Date): string | undefined {
  return date ? String(date.getTime() / 1000) : undefined;
}
